(() => {
  const formatMoney = (cents) => {
    if (typeof Utility !== 'undefined' && typeof Utility.formatMoney === 'function') {
      return Utility.formatMoney(cents, window.globalSpace?.money_format);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      maximumFractionDigits: 0
    }).format(cents / 100);
  };

  const updateStartingPrices = () => {
    document.querySelectorAll('[data-matrix-starting-price]').forEach((priceElement) => {
      const basePrice = Number(priceElement.dataset.priceCents);
      const salePrice = Number(priceElement.dataset.discountPrice);
      const compareAt = Number(priceElement.dataset.discountCompareAt);

      if (!Number.isFinite(basePrice) || basePrice <= 0 || !Number.isFinite(salePrice) || !Number.isFinite(compareAt) || compareAt <= salePrice) return;

      const discountedPrice = Math.round(basePrice * salePrice / compareAt);
      const discountPercentage = Math.round((compareAt - salePrice) * 100 / compareAt);
      priceElement.textContent = formatMoney(discountedPrice);
      priceElement.classList.add('discounted-price');

      const card = priceElement.closest('.price-block') || priceElement.parentElement;
      const comparePriceElement = card?.querySelector('[data-compare-price]');
      if (comparePriceElement) {
        comparePriceElement.innerHTML = `<del class="money">${formatMoney(basePrice)}</del>`;
        comparePriceElement.classList.remove('d-none');
      }

      const discountLabel = card?.querySelector('[data-discountPercentage]');
      if (discountLabel) {
        discountLabel.textContent = `(-${discountPercentage}%)`;
        discountLabel.classList.remove('d-none');
      }

      const installationSuffix = card?.querySelector('[data-price-installation-suffix]');
      installationSuffix?.classList.add('discounted-price');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateStartingPrices, { once: true });
  } else {
    updateStartingPrices();
  }
})();
